// Plain text with its URLs rendered as real links that open in a new tab —
// used by the draft preview cards so John can test a proposed reply's links
// before sending. Whitespace/line breaks are preserved by the PARENT's
// white-space styling (the cards already use pre-wrap); this component only
// swaps URL runs for anchors.

import { splitLinkSegments } from '../../utils/linkify';

export default function LinkifiedText({ text }: { text: string }) {
  return (
    <>
      {splitLinkSegments(text).map((seg, i) =>
        seg.href ? (
          <a
            key={`${i}-${seg.href}`}
            href={seg.href}
            target="_blank"
            rel="noopener noreferrer"
            title={`Open ${seg.href} in a new tab`}
          >
            {seg.text}
          </a>
        ) : (
          <span key={i}>{seg.text}</span>
        ),
      )}
    </>
  );
}
